(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6320],{

/***/ 8822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _image_button_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4874);
/* harmony import */ var _image_button_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_image_button_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var ImageButton = function ImageButton(_ref) {
  var children = _ref.children,
      type = _ref.type,
      action = _ref.action;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: (_image_button_module_css__WEBPACK_IMPORTED_MODULE_2___default())[type],
    onClick: action,
    style: {
      minHeight: "20px",
      minWidth: "20px",
      display: "block"
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ImageButton);

/***/ }),

/***/ 366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ ImageButton/* default */.Z; }
});

// UNUSED EXPORTS: ShareButton

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(9243);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(6869);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(8097);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(600);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5258);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Buttons/ImageButton.js
var ImageButton = __webpack_require__(8822);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Buttons/ShareButton.js








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }







var ShareButton = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ShareButton, _React$Component);

  var _super = _createSuper(ShareButton);

  function ShareButton(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ShareButton);

    _this = _super.call(this, props);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "share", function () {
      if (navigator.share) {
        navigator.share({
          url: window.location.href,
          title: _this.state.title | "Dm 2 Buy"
        }).then(function () {
          _this.setState({
            isShared: true
          });
        });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function () {
          _this.setState({
            isShared: true
          });

          if (_this.props.toast) {
            _this.props.toast();
          }
        });
        console.log("copied");
      } else {
        alert("Share unavailable!");
      }
    });

    var _props$title = props.title,
        title = _props$title.title,
        toast = _props$title.toast;
    var isShared = false;
    _this.state = {
      isShared: isShared,
      title: title,
      toast: toast
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ShareButton, [{
    key: "render",
    value: function render() {
      var isShared = this.state.isShared; // console.log(" ShareButton STATE", isShared);

      var imageButtonType = isShared ? "disabled" : "raised";
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ImageButton/* default */.Z, {
        type: imageButtonType,
        action: this.share,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/shape@2x.png",
          width: "20",
          height: "20"
        })
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }]);

  return ShareButton;
}(react.Component);

/* harmony default export */ var Buttons_ShareButton = ((/* unused pure expression or super */ null && (ShareButton)));
;// CONCATENATED MODULE: ./components/Buttons/index.js




/***/ }),

/***/ 4035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5258);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CartIconSvg = function CartIconSvg(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "0%",
          stopColor: "#FBB03B"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "100%",
          stopColor: "#E730D5"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fill: "var(--color-primary)",
        fillRule: "nonzero",
        d: "M15.408 4.187h-.715a4.202 4.202 0 0 0-8.405 0h-.853a2.916 2.916 0 0 0-2.861 2.29L.07 17.64a2.93 2.93 0 0 0 2.861 3.573H17.91a2.932 2.932 0 0 0 2.861-3.573L18.269 6.477a2.915 2.915 0 0 0-2.862-2.29zM10.49.953a3.253 3.253 0 0 1 3.249 3.234H7.242A3.251 3.251 0 0 1 10.49.953zm8.964 18.564c-.374.47-.943.743-1.544.742H2.932a1.979 1.979 0 0 1-1.93-2.41L3.504 6.686a1.967 1.967 0 0 1 1.93-1.545h.853v2.294a.477.477 0 1 0 .954 0V5.141h6.499v2.294a.477.477 0 1 0 .954 0V5.141h.714a1.968 1.968 0 0 1 1.93 1.545L19.84 17.85c.133.586-.009 1.2-.386 1.668z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 10.5,
        cy: 13.5,
        r: 2.5,
        fill: "url(#a)"
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (CartIconSvg);

/***/ }),

/***/ 2846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6588);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_ellipsis_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
/* harmony import */ var react_use_scroll_direction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1150);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(366);
/* harmony import */ var _NavBar2_CartIconSvg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4035);
/* harmony import */ var _utils_fileutil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);











var NavBar = function NavBar(props) {
  var _props$store, _props$theme, _props$theme2;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(String),
      _React$useState2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      direction = _React$useState2[0],
      setDirection = _React$useState2[1];

  var _useScrollDirection = (0,react_use_scroll_direction__WEBPACK_IMPORTED_MODULE_3__/* .useScrollDirection */ .C)(),
      isScrollingUp = _useScrollDirection.isScrollingUp,
      isScrollingDown = _useScrollDirection.isScrollingDown;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isSideNavOpen = _useState[0],
      setIsSideNavOpen = _useState[1];

  react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function () {
    isScrollingDown && setDirection("down");
    isScrollingUp && setDirection("up");
  }, [isScrollingDown, isScrollingUp]);

  var checkoutShouldHide = function checkoutShouldHide() {
    var shouldHide = false;

    if (true) {
      if (window.scrollY > 120) {
        shouldHide = true;
      }
    }

    return shouldHide;
  };

  var makeBGWhite = function makeBGWhite() {
    var shouldHide = false;

    if (true) {
      if (window.scrollY > 30) {
        shouldHide = true;
      }
    }

    return shouldHide;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("header", {
    className: "flex flex-row justify-between items-center h-[72px] w-full z-[99] fixed top-0 left-1/2 max-w-[var(--max-width)] bg-transparent -translate-x-1/2 opacity-100 transition-all duration-300 ease-in-out\n        ".concat(direction === "up" ? "bg-white" : "", " \n        ").concat(direction === "down" && checkoutShouldHide() ? "-top-[60px]" : "", " \n        ").concat(direction === "down" && makeBGWhite() ? "!bg-white" : "", " mb-5"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "mx-auto w-full max-w-[var(--max-width)] flex items-center justify-between h-[5rem] p-[0.5rem_22px]",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "relative flex justify-center items-center z-10 w-full",
        children: [props.store.homePageEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("button", {
          className: "bg-transparent border-none absolute left-0",
          onClick: function onClick() {
            console.log("Toggling side navigation:", !isSideNavOpen);
            props.toggleSideNav();
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "block w-6 h-0.5 bg-primary mb-1"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "block w-6 h-0.5 bg-primary mb-1"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "block w-6 h-0.5 bg-primary"
          })]
        }), (_props$store = props.store) !== null && _props$store !== void 0 && _props$store.logo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
          unoptimized: true,
          src: function () {
            var urlPath = props.store.logo ? new URL(props.store.logo).pathname : "";
            var extractedImageName = (0,_utils_fileutil__WEBPACK_IMPORTED_MODULE_8__/* .parseFileName */ .x)(urlPath).name;
            return "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(extractedImageName, ".jpg?quality=50");
          }(),
          alt: "".concat(props.store.storeName, " Logo"),
          width: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.logoShape) === "rectangle" ? 120 : 60,
          height: 60,
          className: "object-contain ".concat(((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.logoShape) === "rectangle" ? "" : "rounded-full"),
          layout: "fixed",
          onClick: function onClick() {
            return window.location.href = window.location.origin;
          }
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
          className: "inline-block text-lg font-bold font-lato text-black text-center",
          onClick: function onClick() {
            return window.location.href = window.location.origin;
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_ellipsis_text__WEBPACK_IMPORTED_MODULE_2__["default"], {
            text: props.storeName,
            length: 25,
            tail: "..."
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
          className: "z-10 absolute right-0",
          children: props.cartActive && !props.hideInAdvance ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_4__/* .ImageButton */ .z, {
            action: function action() {
              return props.handleShowCart(true);
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_NavBar2_CartIconSvg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
          }) : ""
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NavBar);

/***/ }),

/***/ 471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SideNavDrawer; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(2126);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Carousel/ArrowSvg.jsx



var ArrowSvg = function ArrowSvg(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: "icon icon-arrow icon--medium ".concat(className),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.5 3.74121L13.75 9.99121L7.5 16.2412",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/* harmony default export */ var Carousel_ArrowSvg = (ArrowSvg);
;// CONCATENATED MODULE: ./components/SideNavDrawer.jsx







var SideNavDrawer = function SideNavDrawer(_ref) {
  var isOpen = _ref.isOpen,
      toggleDrawer = _ref.toggleDrawer,
      store = _ref.store;
  var router = (0,next_router.useRouter)();

  var _useCollection = (0,useCollection/* default */.Z)(store.id, ""),
      collectionsData = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading,
      collectionsError = _useCollection.error;

  var collections = collectionsData ? collectionsData.collections : [];
  if (collectionsError) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Error loading collections"
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
    className: "fixed top-0 left-0 h-screen w-screen bg-white shadow-lg transition-transform transform z-[101] overflow-y-auto ".concat(isOpen ? "translate-x-0" : "-translate-x-full"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center p-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "font-bold text-lg",
        children: store === null || store === void 0 ? void 0 : store.storeName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "inline-block bg-transparent border-0 w-[22px] absolute top-10 right-5 z-50",
        onClick: toggleDrawer,
        "aria-label": "Close drawer",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full h-[15px] relative transform rotate-0 transition duration-500 ease-in-out cursor-pointer ".concat(isOpen ? "open" : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block absolute h-[2px] w-full bg-primary rounded-lg opacity-100 left-0 transform transition duration-250 ease-in-out top-[7px] ".concat(isOpen ? "rotate-45" : "rotate-0")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block absolute h-[2px] w-full bg-primary rounded-lg opacity-100 left-0 transform transition duration-250 ease-in-out top-[7px] ".concat(isOpen ? "-rotate-45" : "rotate-0")
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
      className: "mt-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "space-y-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "font-normal text-lg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "block px-4 py-2  text-[#1c3142] hover:bg-gray-100",
            onClick: function onClick() {
              return window.location.href = "/";
            },
            children: "Home"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "font-normal text-lg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "block px-4 py-2 text-[#1c3142] hover:bg-gray-100",
            onClick: function onClick() {
              return window.location.href = "/shop";
            },
            children: "Shop"
          })
        }), isCollectionsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {}) : collections.length > 0 && collections.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "font-normal text-lg",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: "px-4 py-2 text-[#1c3142] hover:bg-gray-100 flex justify-between items-center",
              onClick: function onClick() {
                return window.location.href = "/shop?collection=".concat(collection.name);
              },
              children: [collection.name, /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_ArrowSvg, {
                className: "w-5 h-5"
              })]
            })
          }, collection._id);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "font-normal text-lg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "block px-4 py-2  text-[#1c3142] hover:bg-gray-100",
            onClick: function onClick() {
              return router.push("/contact");
            },
            children: "Contact us"
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var components_SideNavDrawer = (SideNavDrawer);

/***/ }),

/***/ 2190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ parseFileName; }
/* harmony export */ });
var parseFileName = function parseFileName(url) {
  if (!url) return "";
  var parts = url.split("/");
  var filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf("."))
  };
};

/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5602);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6661);
/* harmony import */ var _services_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7058);





var fetchCollections = /*#__PURE__*/function () {
  var _ref = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(storeId) {
    var source,
        response,
        _args = arguments;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            source = _args.length > 1 && _args[1] !== undefined ? _args[1] : "featured";
            _context.next = 3;
            return fetch("".concat(_services_helper__WEBPACK_IMPORTED_MODULE_1__/* .publicServerEndpoint */ .v2, "/v3/collection/store/").concat(storeId).concat(source ? "?source=".concat(source) : ""));

          case 3:
            response = _context.sent;

            if (response.ok) {
              _context.next = 6;
              break;
            }

            throw new Error("Failed to fetch collections");

          case 6:
            return _context.abrupt("return", response.json());

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCollections(_x) {
    return _ref.apply(this, arguments);
  };
}();

var useCollection = function useCollection(storeId) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "featured";
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(["collections", storeId, source], function () {
    return fetchCollections(storeId, source);
  }, {
    enabled: !!storeId
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useCollection);

/***/ }),

/***/ 4874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flat":"image-button_flat__dZ1sl","raised":"image-button_raised__pl4uM","disabled":"image-button_disabled__HgfQ9"};

/***/ }),

/***/ 5492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"orderItem":"bag-item_orderItem__qfNaV","productDetails":"bag-item_productDetails__CtRZY","thumbnailContainer":"bag-item_thumbnailContainer__MPJwK","orderThumbnail":"bag-item_orderThumbnail__zsTVG","productColor":"bag-item_productColor__FiiNG","productName":"bag-item_productName__VGY2z","quantityControls":"bag-item_quantityControls__gY_Jn","product_specs":"bag-item_product_specs__oC3OI","details_right":"bag-item_details_right__Q3sLu","productPrice":"bag-item_productPrice__SIffP","attachmentLink":"bag-item_attachmentLink__lY3Jm","fileName":"bag-item_fileName__eFy8x"};

/***/ }),

/***/ 214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","cart":"Home_cart__LyzTg","about":"Home_about__6Y_1_","profilePic":"Home_profilePic__7nemD","footerTagline":"Home_footerTagline__wH1if","notFound":"Home_notFound___6xAl","notFoundMessage":"Home_notFoundMessage__KeTwU","notFoundHeadHome":"Home_notFoundHeadHome__0_jo1","link":"Home_link__mt0ji","title404":"Home_title404__7ZWAE"};

/***/ })

}]);